export const getImageURL = (id: string) => {
  return `https://kyle-gough.sirv.com/Images/${id}.png`;
};
